import * as React from 'react';
import * as styles from './Row.css';
import { ICheckoutRowProps } from './types';

export const Row = (props: ICheckoutRowProps) => {
  const { name, value } = props;

  return (
    <div className={styles['row']}>
      <div className={styles['row_name']}>{name}</div>
      <div className={styles['row_value']}>{value}</div>
    </div>
  );
};
